import * as WebviewActions from '../actionTypes/webview';
import { observable } from '../utils/events';

export function showWebview({ uri, size }) {
    observable.trigger('webview:opened');
    return {
        type: WebviewActions.SHOW_WEBVIEW,
        uri,
        size,
    };
}

export function hideWebview() {
    observable.trigger('webview:closed');
    return {
        type: WebviewActions.HIDE_WEBVIEW,
    };
}

export function showWebviewContent() {
    return {
        type: WebviewActions.SHOW_WEBVIEW_CONTENT,
    };
}

export function hideWebviewContent() {
    return {
        type: WebviewActions.HIDE_WEBVIEW_CONTENT,
    };
}

export function updateWebviewTitle(title) {
    return {
        type: WebviewActions.UPDATE_WEBVIEW_TITLE,
        title,
    };
}

export function resetWebview() {
    return {
        type: WebviewActions.RESET_WEBVIEW,
    };
}
